import { render, staticRenderFns } from "./EDialog.vue?vue&type=template&id=70065162"
import script from "./EDialog.vue?vue&type=script&lang=js"
export * from "./EDialog.vue?vue&type=script&lang=js"
import style0 from "./EDialog.vue?vue&type=style&index=0&id=70065162&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports